const nowToIso = () => new Date().toISOString();

export default nowToIso;
